import { useSelector } from 'react-redux';

export default function useInAuth() {
  const authToken = useSelector((state) => state.auth.persist.authToken);
  const onboardingStatus = useSelector(
    (state) => state.signup.persist.onboardingStatus,
  );
  return !authToken || onboardingStatus !== 'initial';
}
